/**
 * Variant selector component
 * 
 * @module variant-selector
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'variant-selector';

if(!customElements.get(customElements.component)) {

    class variantSelector extends HTMLElement {

        /**
         * Variant selector web component
         * 
         * @constructor
         */
        constructor() {

            super();

            window.theme.product.loadProduct(this.dataset.handle, true).then(product => {

                this.render(product);
            });
        }
        
        /**
         * Init component events
         * 
         * @param {object} product Product data.
         * @returns {undefined}
         */
        initEvents(product) {

            let select = this.querySelector('select');

            if (select) {

                // Trigger event on it to select the first variant available
                this.triggerVariantChange(select.value, product);

                select.addEventListener('change', event => {
                    this.triggerVariantChange(event.target.value, product);
                });
            }
        }

        /**
         * Render component in the DOM
         * 
         * @param {object} product Product data.
         * @returns {undefined}
         */
        render(product) {
            
            if (this.getTemplate()) {

                let html = this.getTemplate();

                // Load options

                let options = '';

                // TODO: We need to improve this code to remove or hide the dependency of the swatch terms.
                product.variants.forEach((variant, index) => {

                    let reference = '';

                    product.options.forEach((option, index) => {

                        // We are using this data to handle out of stock swatches
                        reference = reference + ` data-swatches-option-${option.name.replace(/ /g, '-')}="${variant.options[index].replace(/ /g, '-')}"`;
                    });
                    
                    if (variant.available) {

                        options = options + `<option data-index="${index}" data-variant-id="${variant.id}" ${reference} value="${variant.id}" data-enabled>${variant.title}</option>`;
                    
                    } else {

                        options = options + `<option data-index="${index}" data-variant-id="${variant.id}" ${reference} value="${variant.id}" data-disabled>${variant.title} - Sold Out</option>`;
                    }
                });

                html = html.replace(/{{options}}/g, options);

                // Inject HTML
                this.innerHTML = html;

                let firstVariantEnabled = this.querySelector("select [data-enabled]");

                if (firstVariantEnabled) {
                    this.querySelector("select").selectedIndex = firstVariantEnabled.dataset.index;
                }

                this.initEvents(product);
                this.triggerRender(product);
            }
        }

        /**
         * Get component template
         * 
         * @returns {string} Component HTML template.
         */
        getTemplate() {

            return `<select name="id">{{options}}</select>`;
        }

        /**
         * Trigger render
         * 
         * @param {object} product Product data.
         * @returns {object} Event Trigger ready.
         */
        triggerRender(product) {

            this.classList.add('ready');

            let event = new CustomEvent('ready', {'detail': {
                product: product
            }});
    
            this.dispatchEvent(event);
    
            return event;
        }

        /**
         * Trigger variant change with data
         * 
         * @public
         * @method
         * @name triggerVariantChange
         * @param {integer} variantId Variant id.
         * @param {object} product Product data.
         * @fires variant-change
         * @returns {object} Event variant-change.
         */
        triggerVariantChange(variantId, product) {

            let eventDetails =  {
                variantId: variantId,
                variant: window.theme.product.getVariant(variantId, product),
                product: product
            };

            let isQuickviewTrigger = (typeof this.dataset.variantSelectorQuickview != 'undefined') ? true : false;
            if(isQuickviewTrigger){
                eventDetails = { 
                    ...eventDetails,
                    isQuickviewTrigger: true
                }
            }

            let event = new CustomEvent('variant-change', {'detail': eventDetails});

            window.dispatchEvent(event);

            return event;
        }
    }

    customElements.define(customElements.component, variantSelector);
}
